import { useState, useCallback } from 'react';

// Remembered collapse/expand state per section, persisted in localStorage.
export default function useCollapsePref(id, defaultOpen = false) {
  const key = `neurowave_collapse_${id}`;
  const [open, setOpen] = useState(() => {
    try {
      const v = localStorage.getItem(key);
      return v === null ? defaultOpen : v === '1';
    } catch {
      return defaultOpen;
    }
  });
  const toggle = useCallback(() => {
    setOpen((o) => {
      try { localStorage.setItem(key, o ? '0' : '1'); } catch {}
      return !o;
    });
  }, [key]);
  return [open, toggle];
}
